<script>
  export let language = "ru",
    page = document.body;

  export function toggleState() {
    active = !active;
  }

  function readSettings() {
    const entry = localStorage.getItem("ImpairedPanel");
    if (entry == null || entry == "") return;
    try {
      const settings = JSON.parse(entry);
      active = settings.active;
      fontFamily = settings.fontFamily;
      fontSize = settings.fontSize;
      images = settings.images;
      letterSpacing = settings.letterSpacing;
      theme = settings.theme;
    } catch (e) {
      console.error(e);
    }
  }

  function writeSettings() {
    const settings = {
      active,
      fontFamily,
      fontSize,
      images,
      letterSpacing,
      theme,
    };
    localStorage.setItem("ImpairedPanel", JSON.stringify(settings));
  }

  function applySpecialRules() {
    page.classList.add(CSS_CLASSES._root);

    page.querySelectorAll(".vi-visible").forEach((el) => {
      el.style.display = "inherit";
      el.style.opacity = 1;
      el.style.visibility = "visible";
    });

    page.querySelectorAll(".vi-invisible").forEach((el) => {
      el.style.display = "none";
    });
  }

  function removeSpecialRules() {
    page.classList.remove.apply(page.classList, Object.values(CSS_CLASSES));

    page.querySelectorAll(".vi-visible").forEach((el) => {
      el.style.display = null;
      el.style.opacity = null;
      el.style.visibility = null;
    });

    page.querySelectorAll(".vi-invisible").forEach((el) => {
      el.style.display = null;
    });
  }

  function changeFontFamily() {
    switch (fontFamily) {
      case "sans":
        page.classList.remove(CSS_CLASSES.fontFamilySerif);
        page.classList.add(CSS_CLASSES.fontFamilySans);
        break;
      case "serif":
        page.classList.remove(CSS_CLASSES.fontFamilySans);
        page.classList.add(CSS_CLASSES.fontFamilySerif);
        break;
    }
  }

  function changeFontSize() {
    switch (fontSize) {
      case 1:
        page.classList.remove(CSS_CLASSES.fontSize2, CSS_CLASSES.fontSize3);
        break;
      case 2:
        page.classList.remove(CSS_CLASSES.fontSize3);
        page.classList.add(CSS_CLASSES.fontSize2);
        break;
      case 3:
        page.classList.remove(CSS_CLASSES.fontSize2);
        page.classList.add(CSS_CLASSES.fontSize3);
        break;
    }
  }

  function changeImages() {
    switch (images) {
      case 1:
        page.classList.remove(
          CSS_CLASSES.imagesGrayscale,
          CSS_CLASSES.imagesOff
        );
        break;
      case 2:
        page.classList.remove(CSS_CLASSES.imagesOff);
        page.classList.add(CSS_CLASSES.imagesGrayscale);
        break;
      case 3:
        page.classList.remove(CSS_CLASSES.imagesGrayscale);
        page.classList.add(CSS_CLASSES.imagesOff);
        break;
    }
  }

  function changeLetterSpacing() {
    switch (letterSpacing) {
      case 1:
        page.classList.remove(
          CSS_CLASSES.letterSpacing2,
          CSS_CLASSES.letterSpacing3
        );
        break;
      case 2:
        page.classList.remove(CSS_CLASSES.letterSpacing3);
        page.classList.add(CSS_CLASSES.letterSpacing2);
        break;
      case 3:
        page.classList.remove(CSS_CLASSES.letterSpacing2);
        page.classList.add(CSS_CLASSES.letterSpacing3);
        break;
    }
  }

  function changeTheme() {
    switch (theme) {
      case 1:
        page.classList.remove(CSS_CLASSES.theme2, CSS_CLASSES.theme3);
        page.classList.add(CSS_CLASSES.theme1);
        break;
      case 2:
        page.classList.remove(CSS_CLASSES.theme1, CSS_CLASSES.theme3);
        page.classList.add(CSS_CLASSES.theme2);
        break;
      case 3:
        page.classList.remove(CSS_CLASSES.theme1, CSS_CLASSES.theme2);
        page.classList.add(CSS_CLASSES.theme3);
        break;
    }
  }

  $: active ? applySpecialRules() : removeSpecialRules();
  $: {
    fontFamily;
    active && changeFontFamily();
  }
  $: {
    fontSize;
    active && changeFontSize();
  }
  $: {
    images;
    active && changeImages();
  }
  $: {
    letterSpacing;
    active && changeLetterSpacing();
  }
  $: {
    theme;
    active && changeTheme();
  }
  $: {
    active;
    fontFamily;
    fontSize;
    images;
    letterSpacing;
    theme;
    writeSettings();
  }

  // На основе https://slabovid.ru/info/access/img/r0_yt0zj5qtcy-bqmtzlaxwhbr8.png
  const TEXTS = {
    en: {
      exit: "Back to normal view",
      fontFamily: "Font family",
      fontFamilySans: "Sans-serif",
      fontFamilySerif: "Serif",
      fontSize: "Font size",
      fontSize1: "Normal",
      fontSize2: "Larger",
      fontSize3: "Large",
      images: "Images",
      imagesGrayscale: "Grayscale",
      imagesOff: "Off",
      imagesOn: "On",
      letterSpacing: "Letter spacing",
      letterSpacing1: "Normal",
      letterSpacing2: "Extended",
      letterSpacing3: "Large",
      theme: "Theme",
      theme1: "Black on white",
      theme2: "White on black",
      theme3: "Yellow on dark violet",
    },
    ru: {
      exit: "Вернуться к обычному виду",
      fontFamily: "Шрифт",
      fontFamilySans: "Без засечек", // sans-serif
      fontFamilySerif: "С засечками", // serif
      fontSize: "Размер шрифта",
      fontSize1: "Нормальный",
      fontSize2: "Увеличенный",
      fontSize3: "Большой",
      images: "Изображения",
      imagesGrayscale: "Серые",
      imagesOff: "Скрыть",
      imagesOn: "Показать",
      letterSpacing: "Интервал между буквами",
      letterSpacing1: "Нормальный",
      letterSpacing2: "Увеличенный",
      letterSpacing3: "Большой",
      theme: "Цвет сайта",
      theme1: "Чёрный на белом",
      theme2: "Белый на чёрном",
      theme3: "Жёлтый на тёмно-фиолетовом",
    },
  };

  const CSS_CLASSES = {
    _root: "vi-root",
    fontFamilySans: "vi-root--sans",
    fontFamilySerif: "vi-root--serif",
    fontSize2: "vi-root--font-size-2",
    fontSize3: "vi-root--font-size-3",
    imagesGrayscale: "vi-root--images-grayscale",
    imagesOff: "vi-root--images-off",
    letterSpacing2: "vi-root--ls2",
    letterSpacing3: "vi-root--ls3",
    theme1: "vi-root--theme1",
    theme2: "vi-root--theme2",
    theme3: "vi-root--theme3",
  };

  let active = false;
  let fontFamily = "sans";
  let fontSize = 1;
  let images = 1; // 1: on, 2: grayscale, 3: off
  let letterSpacing = 1;
  let theme = 1;

  readSettings();
</script>

{#if active}
  <div class={`vi-stripe theme${theme}`}>
    <div class="panel">
      <div class="contents">
        <span class="item">
          <span class="label">{TEXTS[language].fontSize}</span>
          <button
            class="btn"
            class:active={fontSize == 1}
            style="font-size: smaller;"
            title={TEXTS[language].fontSize1}
            on:click={() => {
              fontSize = 1;
            }}
          >
            A
          </button>
          <button
            class="btn"
            class:active={fontSize == 2}
            title={TEXTS[language].fontSize2}
            on:click={() => {
              fontSize = 2;
            }}
          >
            A
          </button>
          <button
            class="btn"
            class:active={fontSize == 3}
            style="font-size: larger;"
            title={TEXTS[language].fontSize3}
            on:click={() => {
              fontSize = 3;
            }}
          >
            A
          </button>
        </span>

        <span class="item">
          <span class="label">{TEXTS[language].theme}</span>
          <button
            class="btn"
            class:active={theme == 1}
            style="background-color: white; color: black;"
            title={TEXTS[language].theme1}
            on:click={() => {
              theme = 1;
            }}
          >
            A
          </button>
          <button
            class="btn"
            class:active={theme == 2}
            style="background-color: black; color: white;"
            title={TEXTS[language].theme2}
            on:click={() => {
              theme = 2;
            }}
          >
            A
          </button>
          <button
            class="btn"
            class:active={theme == 3}
            style="background-color: indigo; color: yellow;"
            title={TEXTS[language].theme3}
            on:click={() => {
              theme = 3;
            }}
          >
            A
          </button>
        </span>

        <span class="item">
          <span class="label">{TEXTS[language].images}</span>
          <button
            class="btn border"
            class:active={images == 1}
            on:click={() => {
              images = 1;
            }}
          >
            {TEXTS[language].imagesOn}
          </button>
          <button
            class="btn border"
            class:active={images == 2}
            on:click={() => {
              images = 2;
            }}
          >
            {TEXTS[language].imagesGrayscale}
          </button>
          <button
            class="btn border"
            class:active={images == 3}
            on:click={() => {
              images = 3;
            }}
          >
            {TEXTS[language].imagesOff}
          </button>
        </span>

        <span class="item">
          <span class="label">{TEXTS[language].letterSpacing}</span>
          <button
            class="btn border"
            class:active={letterSpacing == 1}
            on:click={() => {
              letterSpacing = 1;
            }}
          >
            {TEXTS[language].letterSpacing1}
          </button>
          <button
            class="btn border"
            class:active={letterSpacing == 2}
            on:click={() => {
              letterSpacing = 2;
            }}
          >
            {TEXTS[language].letterSpacing2}
          </button>
          <button
            class="btn border"
            class:active={letterSpacing == 3}
            on:click={() => {
              letterSpacing = 3;
            }}
          >
            {TEXTS[language].letterSpacing3}
          </button>
        </span>

        <span class="item">
          <span class="label">{TEXTS[language].fontFamily}</span>
          <button
            class="btn border"
            class:active={fontFamily == "sans"}
            on:click={() => {
              fontFamily = "sans";
            }}
          >
            {TEXTS[language].fontFamilySans}
          </button>
          <button
            class="btn border"
            class:active={fontFamily == "serif"}
            on:click={() => {
              fontFamily = "serif";
            }}
          >
            {TEXTS[language].fontFamilySerif}
          </button>
        </span>

        <span class="item">
          <button class="btn border" on:click={toggleState}
            >{TEXTS[language].exit}</button
          >
        </span>
      </div>
    </div>
  </div>
{/if}

<style global>
  .vi-root {}
  .vi-root--sans * {
    font-family: sans-serif;
  }
  .vi-root--serif * {
    font-family: serif;
  }
  .vi-root--font-size-2 * {
    font-size: 1.2rem;
  }
  .vi-root--font-size-3 * {
    font-size: 1.4rem;
  }
  .vi-root--images-grayscale img {
    filter: grayscale(100%) !important;
  }
  .vi-root--images-off img {
    display: none !important;
  }
  .vi-root--ls2 * {
    letter-spacing: 0.05rem;
  }
  .vi-root--ls3 * {
    letter-spacing: 0.1rem;
  }
  .vi-root--theme1,
  .vi-root--theme1 * {
    background-color: white;
    color: black;
  }
  .vi-root--theme2,
  .vi-root--theme2 * {
    background-color: black;
    color: white;
  }
  .vi-root--theme3,
  .vi-root--theme3 * {
    background-color: indigo;
    color: yellow;
  }

  .vi-stripe {
    position: fixed;
    top: 0;
    left: 0;
    right: 0;
    z-index: 99999;
    background: white;
    border-bottom: 1px solid #ccc;
  }
  .vi-stripe .panel {
    margin: 0 auto;
    padding: 0.5rem;
    max-width: 900px;
  }
  .vi-stripe .contents {
    display: flex;
    flex-wrap: wrap;
    align-items: start;
    justify-content: space-between;
    gap: 1.5rem 2rem;
  }

  .vi-stripe.theme1 {
    border: 1px solid black;
    background-color: white;
    color: black;
  }
  .vi-stripe.theme2 {
    border: 1px solid white;
    background-color: black;
    color: white;
  }
  .vi-stripe.theme3 {
    border: 1px solid yellow;
    background-color: indigo;
    color: yellow;
  }

  .vi-stripe .item {
    display: flex;
    line-height: 1.8rem;
  }
  .vi-stripe .label {
    margin-right: 0.5rem;
  }

  .vi-stripe .btn {
    background-color: transparent;
    border: 1px solid transparent;
    cursor: pointer;
    margin-right: 0.25rem;
    padding: 0 0.5rem;
  }
  .vi-stripe .btn.active {
    font-weight: 700;
  }

  .vi-stripe.theme1 .btn:hover {
    border-color: indianred !important;
  }
  .vi-stripe.theme1 .btn.border {
    border-color: black;
  }
  .vi-stripe.theme1 .btn.active,
  .vi-stripe.theme1 .btn.active.border {
    border-color: orange;
    color: orange;
  }

  .vi-stripe.theme2 .btn:hover {
    border-color: indianred !important;
  }
  .vi-stripe.theme2 .btn.border {
    border-color: white;
  }
  .vi-stripe.theme2 .btn.active,
  .vi-stripe.theme2 .btn.active.border {
    border-color: orange;
    color: orange;
  }

  .vi-stripe.theme3 .btn:hover {
    border-color: beige !important;
  }
  .vi-stripe.theme3 .btn.border {
    border-color: white;
  }
  .vi-stripe.theme3 .btn.active,
  .vi-stripe.theme3 .btn.active.border {
    border-color: bisque;
    color: bisque;
  }
</style>
